import { categoryList } from '@/store/dict/rentPlanDict'
import SelectOption from '@/store/dict/selectOptionDict'
import { TEMPLATE_STATE } from '@/store/dict/templateDict.js'
import { PLAN_TYPE_TEXT } from '../../const'

export const STATE_ENUM = {
  ABLE: 1, // 可用
  DISABLE: 0, // 不可用
}
export const DIALOG_CONFIG = {
  [STATE_ENUM.ABLE]: {
    title: '下架租赁方案',
    contentTxt: '确认下架该租赁方案',
    sureBtnText: '确定',
  },
  [STATE_ENUM.DISABLE]: {
    title: '上架租赁方案',
    contentTxt: '确认上架该租赁方案',
    sureBtnText: '确定',
  },
}

// 0: '上架', 1: '下架'
export const STATE_ENUM_TEXT = {
  [STATE_ENUM.ABLE]: '下架',
  [STATE_ENUM.DISABLE]: '上架',
}
export const TYPE_ENUM = {
  ADDOREDIT: 1, // 可用
  DELETE: -1, // 删除
}

const ProductState = {
  10: '上架',
  0: '下架',
  2: '待补齐信息',
}
export default function () {
  const tableColumns = [
    {
      name: 'id',
      columnProps: {
        prop: 'id',
        label: '方案ID',
      },
      render: ({ row }) => {
        return (
          <el-link
            type="primary"
            onClick={() => this.goDetail(row)}
          >
            {row.id}
          </el-link>
        )
      },
    },
    {
      name: 'showCityCodes',
      columnProps: {
        prop: 'showCityCodes',
        label: '方案所属城市',
        width: 160,
      },
      showEllipsisTooltip: true,
      limitEllipsisLine: 1,
      getText: ({ row }) => {
        const { showCityCodes } = row
        if (showCityCodes?.length === 0) return '--'
        if (showCityCodes.length === 1) {
          return showCityCodes?.[0]
        }
        return showCityCodes.join(',')
      },
    },
    {
      name: 'name',
      columnProps: {
        prop: 'name',
        label: '方案名称',
        width: 160,
      },
    },
    {
      name: 'productList',
      columnProps: {
        prop: 'productList',
        label: '关联商品',
        width: 160,
      },
      render: ({ row }) => {
        const { productList } = row
        if (!productList || productList?.length === 0) return '--'
        return productList.map((item) => {
          const { id, state } = item
          return (
            <el-link
              type="primary"
              onClick={() => this.goProductDetail(id)}
              class="product-link"
            >
              {id}（{ProductState[state]}）
            </el-link>
          )
        })
      },
    },
    {
      name: 'brandName',
      columnProps: {
        prop: 'brandName',
        label: '品牌',
      },
    },
    {
      name: 'seriesName',
      columnProps: {
        prop: 'seriesName',
        label: '车系',
      },
    },
    {
      name: 'modelName',
      columnProps: {
        prop: 'modelName',
        label: '车型',
        width: 160,
      },
    },
    {
      name: 'typeId',
      columnProps: {
        prop: 'typeId',
        label: '方案类型',
        width: 120,
      },
      getText: ({ row }) => {
        const type = PLAN_TYPE_TEXT[row.orderType]
        return type ? `${type}租赁方案` : '--'
      },
    },
    {
      name: 'rentCategory',
      columnProps: {
        prop: 'rentCategory',
        label: '租赁类型',
        width: 120,
      },
      getText: ({ row }) => categoryList[row.rentCategory] || '--',
    },
    {
      name: 'templateName',
      columnProps: {
        prop: 'templateName',
        label: '合同模板名称',
        width: 160,
      },
    },
    {
      name: 'templateState',
      columnProps: {
        prop: 'templateState',
        label: '合同状态',
        width: 120,
      },
      getText: ({ row }) => TEMPLATE_STATE[row.templateState] || '--',
    },
    {
      name: 'state',
      columnProps: {
        prop: 'state',
        label: '方案状态',
      },
      source: SelectOption.leasingSchemeState,
    },
    {
      name: 'rentPeriod',
      columnProps: {
        prop: 'rentPeriod',
        label: '租期',
      },
      getText: ({ row }) => {
        const { rentPeriodType, rentPeriod } = row
        if (rentPeriodType === 1) {
          return `${rentPeriod}天`
        }
        if (rentPeriodType === 3) {
          return `${rentPeriod}个月`
        }
        return '--'
      },
    },
    {
      name: 'rentAmount',
      columnProps: {
        prop: 'rentAmount',
        label: '每期租金(元)',
        width: 100,
      },
    },
    {
      name: 'deposit',
      columnProps: {
        prop: 'deposit',
        label: '押金(元)',
      },
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        width: 140,
        fixed: 'right',
      },
      type: 'operate',
      maxShowLength: 3,
      getOperateList: ({ row }) => {
        const btns = []
        const { state, orderType, rentCategory, rentPayPlanType } = row
        // 上下架
        if (this.judgePermission('for_rent_config_ren_plan_up_and_down')) {
          btns.push({
            label: STATE_ENUM_TEXT[state],
            action: () => this.clickHandle(row, { type: TYPE_ENUM.ADDOREDIT }),
          })
        }
        // 个人租赁方案上架状态也允许编辑
        const hasCopyPermission = this.judgePermission('for_rent_config_ren_plan_edit')
        if (hasCopyPermission && (orderType === 1 || state === STATE_ENUM.DISABLE)) {
          btns.push({
            label: '编辑',
            action: () => this.goEditPage(row),
          })
        }

        if (this.judgePermission('for_rent_config_ren_plan_copy')) {
          btns.push({
            label: '复制',
            action: () => this.copy(row),
          })
        }

        // 只对个人租赁方案（orderType === 1）且上架状态（state === 1）显示
        const isPersonalPlan = orderType === 1
        const isOnShelf = state === STATE_ENUM.ABLE
        // 新增：必须是纯租（rentCategory === 1）
        const isPureRent = rentCategory === 1
        // 新增：必须是固定方案（rentPayPlanType === 0）
        const isFixedPlan = rentPayPlanType === 0
        // TODO: 确认权限码，暂时复用方案上下架权限
        const hasPermission = this.judgePermission('for_rent_config_ren_plan_up_and_down')
        if (isPersonalPlan && isOnShelf && isPureRent && isFixedPlan && hasPermission) {
          btns.push({
            label: '上架商品',
            action: () => this.openBatchPublish(row),
          })
        }
        return btns
      },
    },
  ]

  const urlMap = {
    // 工作台-个人租赁订单
    workbench_rent_order: {
      1: {
        path: '/workbench/rentOrder/list',
        query: {},
      }, // 个人订单
      2: {
        path: '/workbench/entOrder/list',
        query: {
          activeName: 'child',
        },
      }, // 企业子订单
    },
    // 待租-签约提车
    for_rent_sign_contract: {
      1: {
        path: '/car_to_lease/forRentSignContract', // 个人订单
        query: {},
      },
      2: {
        path: '/car_to_lease/forRentSignContract', // 企业子订单
        query: {
          activeName: 'child',
        },
      },
    },
  }
  return {
    tableColumns,
    urlMap,
  }
}
